import { CustomAddChip } from '../../../../../components/CustomAddChip';
import {filterByLabelEmailPhone, userListToLabelEmailPhoneValue} from "../../../../../Apis/functions";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const CustomRestrictions = ({ disabled, selectedUsers, setSelectedUsers, users }) => {
    return (
        <div className='mb-4'>
            <CustomAddChip
                autocompleteId={'slt_cr_add_user'}
                buttonId='btn_cr_add_user'
                label='users'
                selectedList={selectedUsers}
                setSelectedList={setSelectedUsers}
                disabled={disabled}
                chipIcon={null}
                required={false}
                data={userListToLabelEmailPhoneValue(users, 'id', false, PersonChipBlack)}
                filterOptions={filterByLabelEmailPhone}
                noDisabledChip={true}
                showRenderOption={true}
                reset={false}
            />
        </div>
    );
};

export default CustomRestrictions;
